import { useQuery } from "react-query";
import axios from "infra/http";
import { ContaRecorrenteDetalhe } from '../typings';

function useContaRecorrenteDetalhe(id?: string) {
  return useQuery(
    `/v1/conta-recorrente/${id}`,
    async () => {
      const { data } = await axios.get<ContaRecorrenteDetalhe>(
        `/v1/conta-recorrente/${id}`,
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useContaRecorrenteDetalhe;
